import React, { useState, useEffect } from 'react';
import { SETTING_APP_THEME, THEME_LIGHT } from '../constants/Constants';
import { saveSetting, getSetting } from '../service/UtilService';

const defaultValues = {
  theme: THEME_LIGHT,
  setTheme: () => {}
};

export const LiliContext = React.createContext(defaultValues);

export const LiliProvider = ({ children }) => {
  const [theme, setTheme] = useState(THEME_LIGHT);

  // Update theme from local storage
  useEffect(() => {
    const storedTheme = getSetting(SETTING_APP_THEME);
    if (storedTheme) {
      setTheme(storedTheme);
    } else {
      setTheme(THEME_LIGHT);
    }
  }, []); // similar to componentDidMount

  const updateTheme = (t = THEME_LIGHT) => {
    setTheme(t);
    saveSetting(SETTING_APP_THEME, t);
  };

  return (
    <LiliContext.Provider
      value={{
        theme,
        updateTheme
      }}
    >
      {children}
    </LiliContext.Provider>
  );
};
